// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1eQax","additionalInfo":"AgreementModal_additionalInfo__2OH5n"};